module.exports = __webpack_public_path__ + "img/PM2.5μg.fc0014cb.png";